import {
  GET_JEWELSBYVALUE_REQUESTED,
  GET_JEWELSBYVALUE_SUCCESS,
  GET_JEWELSBYVALUE_FAILED,
  GET_CLIENTFACETS_REQUESTED,
  GET_CLIENTFACETS_SUCCESS,
  GET_CLIENTFACETS_FAILED,
  GET_SEARCHCLIENTS_REQUESTED,
  GET_SEARCHCLIENTS_SUCCESS,
  GET_SEARCHCLIENTS_FAILED,
  GET_DEALFACETS_REQUESTED,
  GET_DEALFACETS_SUCCESS,
  GET_DEALFACETS_FAILED,
  GET_SEARCHDEALS_REQUESTED,
  GET_SEARCHDEALS_SUCCESS,
  GET_SEARCHDEALS_FAILED,
  GET_CRIMINAL_REQUESTED,
  GET_CRIMINAL_SUCCESS,
  GET_CRIMINAL_FAILED,
  SEARCH_RESET,
  GET_GOVERNMENT_AGENCY_FAILED,
  GET_GOVERNMENT_AGENCY_SUCCESS,
  GET_GOVERNMENT_AGENCY_REQUESTED,
  FETCH_DEAL_NUMBERS_SUCCESS,
  FETCH_DEAL_NUMBERS_FAILURE,
  GET_GLOBALSEARCH_REQUESTED,
} from '../actions/actionTypes'
import _cloneDeep from 'lodash/cloneDeep'
import { prepareClients } from '../../helpers/common'

const initialState = {
  jewels: [],
  isLoading: false,
  commonError: '',
  isLoadingPageClientSearch: false,
  clientFacetData: {
    term: '',
    amountRangeMinMax: [0, 15000],
    requestsRangeMinMax: [0, 1500],
    selectedCashboxes: {},
    selectedBranches: {},
    timeRange: { startDate: null, endDate: null },
    currentPage: 1,
  },
  indices: null,
  customerSearchResults: null,
  globalSearchResult: null,
  isLoadingPageDealSearch: false,
  dealFacetData: null,
  dealSearchResults: null,
  errorPageSearch: '',
  criminalResults: null,
  isGetFasets: false,
  governmentAgency: [],
  dealNumberMap: {},
}

const searchReducer = (state = _cloneDeep(initialState), action) => {
  switch (action.type) {
    case GET_JEWELSBYVALUE_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: ''
      }
    case GET_JEWELSBYVALUE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        jewels: action.payload
      }
    case GET_JEWELSBYVALUE_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case GET_CLIENTFACETS_REQUESTED:
      return {
        ...state,
        isLoadingPageClientSearch: true,
        errorPageSearch: '',
        isGetFasets: true,
      }
    case GET_CLIENTFACETS_SUCCESS:
      const { dataFacets, results: { results, total } } = action.payload

      return {
        ...state,
        isLoadingPageClientSearch: false,
        isGetFasets: false,
        clientFacetData: { ...state.clientFacetData, ...dataFacets },
        customerSearchResults: {
          total,
          clients: prepareClients(results)
        }
      }
    case GET_CLIENTFACETS_FAILED:
      return {
        ...state,
        isLoadingPageClientSearch: false,
        errorPageSearch: action.payload,
        isGetFasets: false,
      }
    case GET_SEARCHCLIENTS_REQUESTED:
      return {
        ...state,
        isLoadingPageClientSearch: true,
        errorPageSearch: ''
      }
    case GET_SEARCHCLIENTS_SUCCESS:
      return {
        ...state,
        isLoadingPageClientSearch: false,
        indices: action.payload.indices,
        customerSearchResults: {
          total: action.payload.total,
          clients: prepareClients(action.payload.results)
        }
      }
    case GET_SEARCHCLIENTS_FAILED:
      return {
        ...state,
        isLoadingPageClientSearch: false,
        errorPageSearch: action.payload
      }
    case GET_DEALFACETS_REQUESTED:
      return {
        ...state,
        isLoadingPageDealSearch: true,
        errorPageSearch: ''
      }
    case GET_DEALFACETS_SUCCESS:
      const { dealFacetData, resultsDeals } = action.payload
      return {
        ...state,
        isLoadingPageDealSearch: false,
        dealFacetData,
        dealSearchResults: {
          total: resultsDeals.total,
          deals: resultsDeals.results
        }
      }
    case GET_DEALFACETS_FAILED:
      return {
        ...state,
        isLoadingPageDealSearch: false,
        errorPageSearch: action.payload
      }
    case GET_SEARCHDEALS_REQUESTED:
      return {
        ...state,
        isLoadingPageDealSearch: true,
        errorPageSearch: ''
      }
    case GET_SEARCHDEALS_SUCCESS:
      return {
        ...state,
        isLoadingPageDealSearch: false,
        indices: action.payload.indices,
        dealSearchResults: {
          total: action.payload.total,
          deals: action.payload.results
        }
      }
    case GET_SEARCHDEALS_FAILED:
      return {
        ...state,
        isLoadingPageDealSearch: false,
        errorPageSearch: action.payload
      }
    case GET_GLOBALSEARCH_REQUESTED:
      return {
        ...state,
        isLoadingGlobalSearch: true,
        indices: null
      }
    case GET_CRIMINAL_REQUESTED:
      return {
        ...state,
        commonError: ''
      }
    case GET_CRIMINAL_SUCCESS:
      return {
        ...state,
        criminalResults: action.payload.length ? action.payload : null
      }
    case GET_CRIMINAL_FAILED:
      return {
        ...state,
        commonError: action.payload
      }
    case GET_GOVERNMENT_AGENCY_REQUESTED:
      return {
        ...state,
        isLoading: true,
        commonError: ''
      }
    case GET_GOVERNMENT_AGENCY_SUCCESS:
      return {
        ...state,
        authority: [...action.payload],
        governmentAgency: action.payload
      }
    case GET_GOVERNMENT_AGENCY_FAILED:
      return {
        ...state,
        isLoading: false,
        commonError: action.payload
      }
    case SEARCH_RESET:
      return _cloneDeep(initialState)

    case FETCH_DEAL_NUMBERS_SUCCESS:
      return {
        ...state,
        dealNumberMap: action.payload,
        error: null,
      };
    case FETCH_DEAL_NUMBERS_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state
  }
}

export default searchReducer
